<template>
  <div class="number-grow-warp">
    <span
      ref="numberGrow"
      :data-time="time"
      class="number-grow"
      :data-value="value"
      >0</span
    >
  </div>
</template>

<script>
import { defineComponent, onMounted, getCurrentInstance } from "vue";
export default defineComponent({
  name: "vueAnimateNumber",
  props: {
    time: {
      type: Number,
      default: 2,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    console.log(456);
  },
  setup(props) {
    onMounted(() => {
      numberGrow(getCurrentInstance().ctx.$refs.numberGrow);
    });
    const numberGrow = (ele) => {
      const step = (props.value * 10) / (props.time * 1000);
      let current = 0;
      let start = 0;
      let t = setInterval(() => {
        start += step;
        if (start > props.value) {
          clearInterval(Number(t));
          start = props.value;
          t = null;
        }
        if (current === start) {
          return;
        }
        current = start;
        ele.innerHTML = current
          .toFixed(0)
          .toString()
          .replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
      }, 0.1);
    };
    return {
      numberGrow,
    };
  },
});
</script>

<style>
.number-grow-warp {
  transform: translateZ(0);
}
.number-grow {
}
</style>
